import { render, staticRenderFns } from "./new-message.vue?vue&type=template&id=6cfc616a&"
import script from "./new-message.vue?vue&type=script&lang=js&"
export * from "./new-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports